/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListContractsByCompanyResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'CompanyContractInfo',
        },
      },
    },
  }],
} as const;
